import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 14a5 5 0 1 0 10 0a5 5 0 1 0 -10 0","key":"svg-0"}],["path",{"d":"M19 5l-5.4 5.4","key":"svg-1"}],["path",{"d":"M19 5l-5 0","key":"svg-2"}],["path",{"d":"M19 5l0 5","key":"svg-3"}]]

const IconMars = createReactComponent('outline', 'mars', 'Mars', __iconNode);

export default IconMars;